// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const UITheme = {
    UI_THEME_DARK: 'UI_THEME_DARK',
    UI_THEME_LIGHT: 'UI_THEME_LIGHT',
    UI_THEME_USER_PREFERENCE: 'UI_THEME_USER_PREFERENCE',
};
export const UIThemeValue = {
    UI_THEME_DARK: 0,
    UI_THEME_LIGHT: 1,
    UI_THEME_USER_PREFERENCE: 2,
};
export const UserViewType = {
    USER_VIEW_TYPE_SMB: 'USER_VIEW_TYPE_SMB',
    USER_VIEW_TYPE_ADMIN: 'USER_VIEW_TYPE_ADMIN',
};
export const UserViewTypeValue = {
    USER_VIEW_TYPE_SMB: 0,
    USER_VIEW_TYPE_ADMIN: 1,
};
export const PlatformMode = {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
};
export const PlatformModeValue = {
    WEB: 0,
    MOBILE: 1,
};
